import http from './httpService';

const getUser = () => http.get('api/general/user');

export default {
    getUser,
};
